/**
 * @generated SignedSource<<a4b08e443f84b4227435d1ba4d023f3b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SlideContainer_slide",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableOverlay",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LinkSlide_slide"
    }
  ],
  "type": "Slide",
  "abstractKey": null
};

node.hash = "848cc09af99ab996183cd85cebb8a27f";

module.exports = node;
